import React, { useEffect, useRef, useState } from "react";
import { Formik, ErrorMessage } from "formik";
import Swal from "sweetalert2";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as bannerService from "../../../../services/banner.services";
// import CustomCkeditor from "../../../common/customeditor";
import { SWAL_SETTINGS } from "../../../../../../utils/Constants";
import { globalLoader, handleServerValidations } from "../../../../../../utils/commonfunction";
import * as Yup from "yup";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";
import * as manualGuideService from "../../../../services/manual-guide.service";

const AddModuleImage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [previewimage, setPreviewImage] = useState("");
  const [previewimageja, setPreviewImageja] = useState("");
  const [moduleList, setModuleList] = useState([]);
  const params = useParams();
  const [saveType , setSaveType] = useState("");
  const fileInputRef = useRef(null);
  const fileInputRefJa = useRef(null);
  // console.log(params.module_id , "this is module id");

  const [initialValues, setInitialValues] = useState({
    title: "",
    title_ja: "",
    files_ja: "",
    files: "",
    module_id : ""
  });

  useEffect(() => {
    setInitialValues({
      title: state && state?.title ? state.title : "",
      title_ja: state && state?.title_ja ? state.title_ja : "",
      files_ja: "",
      files: "",
      module_id : params.module_id ? params.module_id : ""
    });
    setDataLoaded(true);
  }, []);

  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .required("label_title_error"),
    title_ja: Yup.string().required("Title ja is required "),
    files: Yup.mixed()
      .test("fileType", "supported_file_error", (value) => !value || ["image/jpg", "image/jpeg", "image/png", "image/webp", "image/gif"].includes(value.type))
      .test("fileSize", "image_max_size_error", (value) => !value || value.size <= 1.5 * 1024 * 1024),
    files_ja: Yup.mixed()
      .test("fileType", "supported_file_error", (value) => !value || ["image/jpg", "image/jpeg", "image/png", "image/webp", "image/gif"].includes(value.type))
      .test("fileSize", "image_max_size_error", (value) => !value || value.size <= 1.5 * 1024 * 1024),
      module_id :Yup.string().required("this field is required")
  });

  useEffect(() => {
    let data = { panel_id: params.id };
    manualGuideService
      .moduleList(data)
      .then((response) => {
        console.log("View response-", response);
        setModuleList(response && response.data ? response.data.list : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      {dataLoaded ? (
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validateOnBlur={false}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting, resetForm , setFieldValue }) => {
            globalLoader(true);
            setSubmitted(true);
            let formData = new FormData();
            formData.append("title", values.title);
            formData.append("title_ja", values.title_ja.trim());
            formData.append("image", values.files);
            formData.append("image_ja", values.files_ja);
            formData.append("panel_id" , params.id);
            formData.append("module_id" , values.module_id);
            if(params.order){
              formData.append("order_no"  , params.order)
            }
            manualGuideService
              .AddImageModule(formData)
              .then((response) => {
                setSubmitting(false);
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  globalLoader(false);
                  if(saveType==='Save'){
                     resetForm({ values: "" });
                     setInitialValues({
                     title: "",
                     title_ja: "",
                     files_ja: "",
                     files: "",})
                     setPreviewImage("");
                     setPreviewImageja("");
                     setFieldValue("files", "");
                     setFieldValue("files_ja", "");
                     if (fileInputRef.current) {
                      fileInputRef.current.value = ""; 
                    }
                    if (fileInputRefJa.current) {
                      fileInputRefJa.current.value = ""; 
                    }
                  }
                  else{
                    setTimeout(() => {
                      resetForm({ values: "" });
                      navigate(-1);
                    }, 2000);
                  }
                
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  globalLoader(false);
                  setSubmitted(false);
                }
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched, isSubmitting }) => (
            <form onSubmit={handleSubmit}>
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body p-0">
                      <div>
                        <h6 className="main-content-label mb-3">
                          {t("link_add")} Module Image
                        </h6>
                      </div>
                      <div className="row row-sm">
                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                           Title: <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="title"
                            id="title"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="form-control"
                            placeholder={t("banner_title_placeholder")}
                          />
                          <span className="text-danger d-flex text-left">{errors.title && touched.title && t(errors.title)}</span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                          Title(Japanese):<span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="title_ja"
                            id="title_ja"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title_ja}
                            className="form-control"
                            placeholder={t("banner_title_placeholder")}
                          />
                          <span className="text-danger d-flex text-left">{errors.title_ja && touched.title_ja && errors.title_ja}</span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="status" className="text-left d-flex">
                            Select Module :<span className="requirestar">*</span>{" "}
                          </label>
                          <div className=" select-down-arrow">
                            <select name="module_id" id="module_id" onChange={handleChange} onBlur={handleBlur} value={values.module_id} className="form-control cp">
                              <option value="">Select Module</option>

                              {moduleList.map((item) => {
                                return <option value={item._id}>{item.title}</option>;
                              })}
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">{errors.module_id && touched.module_id && t(errors.module_id)}</span>
                        </div>

                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="files" className="text-left d-flex">
                            {t("label_image")}:
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{t("image_support_tooltip")}</Tooltip>}>
                              <span className="field-more-info mt-1 ms-1 cp">?</span>
                            </Whisper>
                          </label>
                          <input
                            className="form-control imgInput"
                            id="files"
                            name="files"
                            accept="image/*"
                            type="file"
                            ref = {fileInputRef}
                            onChange={(event) => {
                              setFieldValue("files", event.currentTarget.files[0] || "");
                              event.currentTarget.files.length === 1 ? setPreviewImage(URL.createObjectURL(event.currentTarget.files[0])) : setPreviewImage("");
                            }}
                          />
                          <span className="text-danger d-flex text-left" id="errortext">
                            {errors.files && touched.files && t(errors.files)}
                          </span>
                        </div>

                        {previewimage ? (
                          <ul className="question-image-preview questions-ul">
                            <li className="pr_img_box">
                              <img src={previewimage} style={{ height: "100px" }} alt={t("banner-image")} />
                              <div className="img_options">
                                <button
                                  type="button"
                                  className="text-danger"
                                  onClick={() => {
                                    // console.log(previewResImage , previewimage)
                                    setPreviewImage("");
                                    setFieldValue("files", "");
                                    document.getElementById("files").value = "";
                                  }}
                                >
                                  <i className="ri-delete-bin-6-fill"></i>
                                </button>
                              </div>
                            </li>
                          </ul>
                        ) : (
                          ""
                        )}

                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="files" className="text-left d-flex">
                            {t("label_image")}(ja):
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{t("image_support_tooltip")}</Tooltip>}>
                              <span className="field-more-info mt-1 ms-1 cp">?</span>
                            </Whisper>
                          </label>
                          <input
                            className="form-control imgInput"
                            id="files_ja"
                            name="files_ja"
                            ref = {fileInputRefJa}
                            accept="image/*"
                            type="file"
                            onChange={(event) => {
                              setFieldValue("files_ja", event.currentTarget.files[0] || "");
                              event.currentTarget.files.length === 1 ? setPreviewImageja(URL.createObjectURL(event.currentTarget.files[0])) : setPreviewImageja("");
                            }}
                          />
                          <span className="text-danger d-flex text-left" id="errortext">
                            {errors.files_ja && touched.files_ja && t(errors.files_ja)}
                          </span>
                        </div>

                        {previewimageja ? (
                          <ul className="question-image-preview questions-ul">
                            <li className="pr_img_box">
                              <img src={previewimageja} style={{ height: "100px" }} alt={t("banner-image")} />
                              <div className="img_options">
                                <button
                                  type="button"
                                  className="text-danger"
                                  onClick={() => {
                                    // console.log(previewResImage , previewimage)
                                    setPreviewImageja("");
                                    setFieldValue("files_ja", "");
                                    document.getElementById("files_ja").value = "";
                                  }}
                                >
                                  <i className="ri-delete-bin-6-fill"></i>
                                </button>
                              </div>
                            </li>
                          </ul>
                        ) : (
                          ""
                        )}
                        <div className="">
                          <button
                            onClick={() => {
                              setSaveType("Save");
                            }}
                            className="btn btn-info mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save")} & Add More
                          </button>
                          <button className="btn btn-main-primary signbtn mr-2" type="submit" disabled={submitted ? true : null}>
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                              Save & Exit
                          </button>
                          <button className="btn ripple btn-secondary" type="button" disabled={submitted ? true : null} onClick={() => navigate(-1)}>
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default AddModuleImage;
